import { JSX } from "react";

export const Instant = (): JSX.Element => {
    return (
        <svg
            width="14"
            height="12"
            viewBox="0 0 14 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1.75 12V6.75H0.25V5.25H4.75V6.75H3.25V12H1.75ZM1.75 3.75V0H3.25V3.75H1.75ZM4.75 3.75V2.25H6.25V0H7.75V2.25H9.25V3.75H4.75ZM6.25 12V5.25H7.75V12H6.25ZM10.75 12V9.75H9.25V8.25H13.75V9.75H12.25V12H10.75ZM10.75 6.75V0H12.25V6.75H10.75Z"
                fill="#1D2D58"
            />
        </svg>
    );
};
